import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';
import EngineFunctionsDefinition from '../../../definitions/engineFunctionsDefinition';
import LocaleTooling from '../../../tooling/localeTooling';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import TextBox from '../common/inputs/textBox';
import FormulaEditorLink from '../common/inputs/formulaEditorLink';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import SelectList from '../common/inputs/selectList';
import Label from '../common/inputs/label';
import ErrorFeedback from '../common/feedback/errorFeedback';
import ObjectPolynomialReportDetailsEditor from '../common/inputs/objectPolynomialReportDetailsEditor';
import VersionsTable from '../common/versions/versionsTable';
import RichTextInput from '../common/inputs/richTextInput';
import TagsSelector from '../common/inputs/tagsSelector';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    statusPreloading,
    loadingPreloading,
    formData,
    pendingSaveFields,
    errors,
    entityNameSingular,
    popupState,
    handleShowPolynomialVersionPopup,
    handleEditFormulaLink,
    handleEditTableLink,
    handleDeletePolynomialVersion,
    handleEntityQueryDataPopup,
    handleRestorePolynomialVersion,
    handleSaveUserImage,
    dimensionsList,
    tagsOptions,
  } = props;
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage 
         id={loadingPreloading ? "common.entity.loadingEntity" : (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id") ? "common.entity.editEntity" : "common.entity.createEntity")}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={loadingPreloading ? "common.entity.loadingEntity" : (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id") ? "common.entity.editEntity" : "common.entity.createEntity")}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
      handleButton={(statusPreloading==200 || formData.isEmpty) ? handleButton : null}
    >
      {(statusPreloading==200 || formData.isEmpty) && (
        <div>
          <ErrorFeedback
            status={statusButton}
            fieldErrors={errors}
            localesFieldsPath="polynomialAdmin.fields"
            optionalStatusErrors={{
              "406": intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
                 {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "polynomialAdmin.entityNameSingularWithArticle"})), 
                  detail: (errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + errors.message : "")
                 })
            }}
          />
          {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id") && (
            <i 
              className="fas fa-search entity_use_query_icon" 
              data-entityid={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id")} 
              onClick={handleEntityQueryDataPopup}
            />
          )}
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="name"
            data-path="polynomial.name"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.name")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="polynomialAdmin.fields.name"/>}
            className={("name" in errors) ? "has_error" : null}
          />     
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="code"
            data-path="polynomial.code"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.code")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="polynomialAdmin.fields.code"/>}
          />    
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="description"
            data-path="polynomial.description"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.description")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="polynomialAdmin.fields.description"/>}
          />  
          <div className="row_fields">
            {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type") != Constants.selectKeys.polynomial.formulaType.TABLE) && (
              <CheckBox 
                id="model"
                data-path="polynomial.model"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model")}
                onChange={handleOnChangeForm}
                disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id") && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.sub_model")}
                labelLocale={<FormattedMessage id="polynomialAdmin.fields.model"/>}
                className={("model" in errors) ? "has_error" : null}
              />
            )}
            <CheckBox 
              id="kpi"
              data-path="polynomial.kpi"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.kpi")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="polynomialAdmin.fields.kpi"/>}
            />
            {(!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type") != Constants.selectKeys.polynomial.formulaType.TABLE) && (
              <CheckBox 
                id="sub_model"
                data-path="polynomial.sub_model"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.sub_model")}
                onChange={handleOnChangeForm}
                disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id")}
                labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="polynomialAdmin.fields.sub_model"/>)}
              />
            )}
          </div>
          {(!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.sub_model") && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type") != Constants.selectKeys.polynomial.formulaType.TABLE) && (
            <Select 
              id="sub_model_dimension_id"
              data-path="polynomial.sub_model_dimension_id"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.sub_model_dimension_id")}
              onChange={handleOnChangeForm}
              labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="polynomialAdmin.fields.sub_model_dimension_id"/>)}
              disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id")}
              options={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList.filter(item => item.system_entity_class!="CalculationUnit"), "id", "name")}
              className={("sub_model_dimension_id" in errors) ? "has_error" : null}
            />
          )}
          <div className="row_fields">
            <Select 
              id="formula_type"
              data-path="polynomial.formula_type"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="polynomialAdmin.fields.formula_type"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.polynomial.formulaType","polynomialAdmin.fields.selectValues.formula_type", false)}
              className={("formula_type" in errors) ? "has_error" : null}
            />
            {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.kpi") && (
              <FormulaEditorLink 
                data-path="polynomial.goal_lineal_array"
                data-disablemarkmode={"true"}
                data-finalpath="polynomial.goal"
                data-label={intl.formatMessage({id: "polynomialAdmin.fields.goal"})}
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.goal_lineal_array")}
                handleEditFormulaLink={handleEditFormulaLink}
                labelLocale={<FormattedMessage id="polynomialAdmin.fields.goal"/>}
                className={("goal" in errors) ? "has_error" : null}
                pendingSave={"polynomial.goal" in pendingSaveFields}
              />
            )}
          </div>
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type") != Constants.selectKeys.polynomial.formulaType.TABLE) ? (
            <FormulaEditorLink 
              data-path="polynomial.formula_lineal_array"
              data-finalpath="polynomial.formula"
              data-label={intl.formatMessage({id: "polynomialAdmin.fields.formula"})}
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_lineal_array")}
              handleEditFormulaLink={handleEditFormulaLink}
              labelLocale={<FormattedMessage id="polynomialAdmin.fields.formula"/>}
              className={("formula" in errors) ? "has_error" : null}
              pendingSave={"polynomial.formula" in pendingSaveFields}
            />
          ) : (
            <FormulaEditorLink 
              data-path="polynomial.formula_lineal_array"
              data-finalpath="polynomial.formula"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_lineal_array")}
              handleEditFormulaLink={handleEditTableLink}
              labelLocale={<FormattedMessage id="polynomialAdmin.fields.formula_table"/>}
              className={("formula" in errors) ? "has_error" : null}
              pendingSave={"polynomial.formula" in pendingSaveFields}
            />
          )}
          <FormulaEditorLink 
            data-path="polynomial.detail_lineal_array"
            data-disablemarkmode={"true"}
            data-finalpath="polynomial.detail"
            data-label={intl.formatMessage({id: "polynomialAdmin.fields.detail"})}
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.detail_lineal_array")}
            handleEditFormulaLink={handleEditFormulaLink}
            labelLocale={<FormattedMessage id="polynomialAdmin.fields.detail"/>}
            className={("detail" in errors) ? "has_error" : null}
            pendingSave={"polynomial.detail" in pendingSaveFields}
          />
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id") ||
            JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") == true ||
            JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.sub_model") == true
          ) && (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id")) && (
            <div className="row_fields">
              <CheckBox 
                  id="active"
                  data-path="polynomial.active"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.active")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
                />
            </div>
          )}
              {/* {(false && (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") == true ||
                JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.sub_model") == true)
              ) && (
                <CheckBox 
                  id="exclude_from_ux_active_models_lists"
                  data-path="polynomial.exclude_from_ux_active_models_lists"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.exclude_from_ux_active_models_lists")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.exclude_from_ux_active_models_lists"/>}
                />
              )} */}
          <ToggleSection
            title={<FormattedMessage id="polynomialAdmin.fields.reportsConfigTitle"/>}
            comment={<FormattedMessage id={"polynomialAdmin.reportsConfigWarning"}/>}
          >
            <div>
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id="report_label"
                data-path="polynomial.report_label"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.report_label")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="polynomialAdmin.fields.report_label"/>}
                className={("report_label" in errors) ? "has_error" : null}
              />                  
              <RichTextInput 
                onChange={handleOnChangeForm}
                data-path="polynomial.report_rich_description"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.report_rich_description")}
                labelLocale={<FormattedMessage id="polynomialAdmin.fields.report_rich_description"/>}
                handleSaveUserImage={handleSaveUserImage}
              />
              <div className="row_fields">
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  type={Constants.interface.inputs.type.TEXT}
                  id="return_type_format"
                  data-path="polynomial.return_type_format"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.return_type_format")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.return_type_format"/>}
                  className={("return_type_format" in errors) ? "has_error" : null}
                />
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  type={Constants.interface.inputs.type.TEXT}
                  id="detail_format"
                  data-path="polynomial.detail_format"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.detail_format")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.detail_format"/>}
                  className={("detail_format" in errors) ? "has_error" : null}
                />
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                  type={Constants.interface.inputs.type.TEXT}
                  id="order"
                  data-path="polynomial.order"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.order")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.order"/>}
                  className={("order" in errors) ? "has_error" : null}
                />
              </div>
              {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type") != Constants.selectKeys.polynomial.formulaType.TABLE) && (
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                  type={Constants.interface.inputs.type.TEXT}
                  id="report_columns_number"
                  data-path="polynomial.report_columns_number"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.report_columns_number")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.report_columns_number"/>}
                  className={("report_columns_number" in errors) ? "has_error" : null}
                />
              )}
              {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.formula_type") != Constants.selectKeys.polynomial.formulaType.TABLE) && (
                <ObjectPolynomialReportDetailsEditor 
                  id="report_details"
                  data-path="polynomial.report_details"
                  values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.report_details")}
                  onChange={handleOnChangeForm}
                  handleEditFormulaLink={handleEditFormulaLink}
                  pendingSaveFields={pendingSaveFields}
                  className={("report_details" in errors) ? "has_error" : null}
                />
              )}
              <div className="row_fields">
                <CheckBox 
                  id="display_report"
                  data-path="polynomial.display_report"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.display_report")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.display_report"/>}
                />  
                {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.display_report") == true) && (
                  <CheckBox 
                    id="display_report_formula"
                    data-path="polynomial.display_report_formula"
                    value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.display_report_formula")}
                    onChange={handleOnChangeForm}
                    labelLocale={<FormattedMessage id="polynomialAdmin.fields.display_report_formula"/>}
                  />
                )}
              </div>
              <div className="row_fields">
                <CheckBox 
                  id="stop_display_report"
                  data-path="polynomial.stop_display_report"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.stop_display_report")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.stop_display_report"/>}
                />
                {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") == true) && (
                  <CheckBox 
                    id="new_page_for_model"
                    data-path="polynomial.new_page_for_model"
                    value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.new_page_for_model")}
                    onChange={handleOnChangeForm}
                    labelLocale={<FormattedMessage id="polynomialAdmin.fields.new_page_for_model"/>}
                  />
                )}
              </div>              
              {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") == true) && (
                <div className="row_fields">              
                  <CheckBox 
                    id="exclude_model_from_reports"
                    data-path="polynomial.exclude_model_from_reports"
                    value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.exclude_model_from_reports")}
                    onChange={handleOnChangeForm}
                    labelLocale={<FormattedMessage id="polynomialAdmin.fields.exclude_model_from_reports"/>}
                  />            
                  <CheckBox 
                    id="hide_model_from_reports_if_zero"
                    data-path="polynomial.hide_model_from_reports_if_zero"
                    value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.hide_model_from_reports_if_zero")}
                    onChange={handleOnChangeForm}
                    labelLocale={<FormattedMessage id="polynomialAdmin.fields.hide_model_from_reports_if_zero"/>}
                  />
                </div>
              )}
              {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.model") == true) && (
                <div className="row_fields">
                  <CheckBox 
                    id="exclude_model_from_calculation_reports"
                    data-path="polynomial.exclude_model_from_calculation_reports"
                    value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.exclude_model_from_calculation_reports")}
                    onChange={handleOnChangeForm}
                    labelLocale={<FormattedMessage id="polynomialAdmin.fields.exclude_model_from_calculation_reports"/>}
                  />
                </div>
              )}
              <div className="row_fields">
                <CheckBox 
                  id="report_hide_total_block"
                  data-path="polynomial.report_hide_total_block"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.report_hide_total_block")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.report_hide_total_block"/>}
                />
                <CheckBox 
                  id="report_only_first_line_header"
                  data-path="polynomial.report_only_first_line_header"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.report_only_first_line_header")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="polynomialAdmin.fields.report_only_first_line_header"/>}
                />
              </div>
            </div>
          </ToggleSection>
          {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.id") && (
            <VersionsTable
              versions={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.polynomial_versions")}
              onClickVersion={handleShowPolynomialVersionPopup}
              handleDelete={handleDeletePolynomialVersion}
              handleRestore={handleRestorePolynomialVersion}
            />
          )}
          <TagsSelector
            id="tags"
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"polynomial.tags")}
            onClickOption={handleOnChangeForm}
            options={tagsOptions}
            data-path="polynomial.tags"
          />
        </div>
      )}
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/polynomialAdmin/formPopup.jsx